<template>
  <div id="content">
    <Navbar />
    <v-container class="py-4 py-sm-8" fluid max-width="1200">
      <v-row justify="center" align="start" class="mb-4 mb-sm-8 mt-2 mt-sm-5">
        <v-col cols="12" md="8" lg="8" class="mb-4 mb-md-8">
          <v-card v-if="!cartStore.cart.length" class="pa-4 pa-sm-8 rounded-xl text-center">
            <v-icon size="60" size-sm="80" color="grey-lighten-1">mdi-cart-off</v-icon>
            <v-card-title class="text-h6 text-sm-h5 text-md-h4 justify-center">
              Your cart is empty
            </v-card-title>
            <v-card-subtitle class="text-caption text-sm-body-2">
              Looks like you haven't added anything yet
            </v-card-subtitle>
            <v-btn color="primary" size="large" class="mt-4" prepend-icon="mdi-store" @click="$router.push('/service')">
              Browse Products
            </v-btn>
          </v-card>

          <!-- Cart With Items -->
          <template v-else>
            <v-card class="pa-6 rounded-xl cart-wrapper" elevation="2">
              <div class="d-flex justify-space-between align-center mb-6 flex-wrap">
                <div class="d-flex align-center">
                  <i class="mdi-cart mdi v-icon notranslate v-theme--light text-primary mr-3" aria-hidden="true"
                    style="font-size: 36px; height: 36px; width: 36px"></i>
                  <h2 class="text-h6 text-sm-h5 text-md-h4 font-weight-bold">
                    Your Shopping Cart
                  </h2>

                  <span
                    class="v-chip v-theme--light text-primary v-chip--density-default v-chip--size-default v-chip--variant-tonal ml-3">
                    <span class="v-chip__underlay"></span>
                    <div class="v-chip__content" data-no-activator="">
                      {{ cartStore.cart.length }} items
                    </div>
                  </span>
                </div>

                <!-- Clear Cart Button -->
                <!-- <button type="button"
            class="v-btn v-theme--light text-error v-btn--density-default rounded-lg v-btn--size-default v-btn--variant-tonal"> -->
                <!-- <span class="v-btn__overlay"></span>
            <span class="v-btn__underlay"></span>
            <span class="v-btn__prepend">
              <i class="mdi-delete-outline mdi v-icon notranslate v-theme--light v-icon--size-default"
                aria-hidden="true"></i>
            </span> -->
                <!-- <span class="v-btn__content" data-no-activator=""> Clear Cart </span> -->
                <v-btn variant="outlined" size="large" class="mb-7" prepend-icon="mdi-arrow-left"
                  @click="$router.push('/service')">
                  Continue Shopping
                </v-btn>
                <!-- </button> -->
              </div>

              <v-divider class="my-4"></v-divider>

              <!-- Desktop View Table -->
              <v-table class="hidden-sm-and-down">
                <thead>
                  <tr>
                    <th class="text-body-2 sm:text-body-1 md:text-body-1">
                      Product
                    </th>
                    <th class="text-body-2 sm:text-body-1 md:text-body-1">
                      Price
                    </th>
                    <th class="text-body-2 sm:text-body-1 md:text-body-1 text-center">
                      Quantity
                    </th>
                    <th class="text-body-2 sm:text-body-1 md:text-body-1 text-right">
                      Subtotal
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in cartStore.cart" :key="item.id" class="cart-row ">
                    <td class="  py-4">
                      <div class="d-flex align-center">
                        <v-img :src="item.image" class="me-2 item-image"></v-img>

                        <div class="d-flex flex-column">
                          <div class="text-body-1 sm:text-body-2 md:text-body-1 font-weight-bold">
                            {{ item.title }}
                          </div>
                          <div class="text-caption text-grey" v-if="item.short_description">
                            {{ truncateDescription(item.short_description) }}
                          </div>
                        </div>
                      </div>
                    </td>

                    <td class="font-weight-bold text-primary text-body-2 sm:text-body-1 md:text-body-1">
                      Rs. {{ item.current_price }}
                    </td>
                    <td class="text-center">
                      <div class="d-flex align-center justify-center">
                        <v-btn icon variant="tonal" size="small" @click="decreaseQuantity(item)"
                          :disabled="item.quantity <= 50">
                          <v-icon>mdi-minus</v-icon>
                        </v-btn>
                        <!-- <span class="mx-4 text-body-1 sm:text-body-2 md:text-body-1">{{ item.quantity }}</span> -->
                        <v-text-field v-model.number="item.quantity" type="number" density="compact" hide-details
                          min="50" max="9999" class="mx-2" style="width: 100px" @input="
                            cartStore.updateQuantity(item.id, item.quantity)
                            " />

                        <!-- <v-text-field v-model.number="item.quantity" min="1" class="mx-2"
                          @input="cartStore.updateQuantity(item.id, item.quantity + 1);" dense hide-details
                          style="width: 30px; text-align: center;" /> -->
                        <v-btn icon variant="tonal" size="small" @click="increaseQuantity(item)">
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </div>
                    </td>
                    <td class="text-right">
                      <div class="d-flex align-center justify-end">
                        <span class="font-weight-bold mr-2 text-body-2 sm:text-body-1 md:text-body-1">Rs. {{
                          formatPrice(item.subTotal) }}</span>
                        <v-btn icon variant="text" size="small" color="grey" @click="deleteItem(item.id)">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </v-table>
              <!-- Mobile View -->
              <div class="hidden-md-and-up">
                <v-card v-for="item in cartStore.cart" :key="item.id" class="mb-4">
                  <div class="d-flex p-3 rounded-lg elevation-1 bg-white mb-3">
                    <v-img :src="item.image" width="70" height="70" class="rounded-lg mr-3 flex-shrink-0"
                      cover></v-img>
                    <div class="flex-grow-1 d-flex flex-column justify-space-between">
                      <div class="mb-2">
                        <div class="text-body-2 font-weight-medium">{{ item.title }}</div>
                        <div class="text-caption text-grey" v-if="item.short_description">
                          {{ truncateDescription(item.short_description, 30) }}
                        </div>
                      </div>
                      <div class="d-flex align-center justify-space-between">
                        <div class="d-flex align-center">
                          <v-btn icon size="x-small" variant="tonal" @click="decreaseQuantity(item)"
                            :disabled="item.quantity <= 50">
                            <v-icon size="18">mdi-minus</v-icon>
                          </v-btn>
                          <v-text-field v-model.number="item.quantity" type="number" min="50" max="9999"
                            density="compact" hide-details class="mx-2 text-center" style="width: 55px"
                            @change="cartStore.updateQuantity(item.id, item.quantity)" />
                          <v-btn icon size="x-small" variant="tonal" @click="increaseQuantity(item)">
                            <v-icon size="18">mdi-plus</v-icon>
                          </v-btn>
                        </div>
                        <div class="text-body-2 font-weight-bold text-primary">
                          Rs. {{ formatPrice(item.subTotal) }}
                        </div>
                      </div>
                    </div>
                  </div>




                  <v-card-actions class="justify-end">
                    <v-btn variant="text" color="error" size="small" @click="deleteItem(item.id)">
                      Remove
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </div>

              <v-divider class="my-4"></v-divider>
            </v-card>

            <!-- Recently Viewed -->
            <!-- <v-card
              class="mt-8 pa-6 rounded-xl"
              elevation="2"
              v-if="recentProducts.length"
            >
              <h3
                class="text-h5 mb-4 text-body-1 sm:text-body-2 md:text-body-1"
              >
                Recently Viewed
              </h3>
              <v-slide-group show-arrows>
                <v-slide-item
                  v-for="product in recentProducts"
                  :key="product.id"
                >
                  <product-card
                    :product="product"
                    class="ma-2"
                    style="width: 200px"
                    @click="$router.push(`/products/${product.id}`)"
                  />
                </v-slide-item>
              </v-slide-group>
            </v-card> -->
          </template>
        </v-col>
        <v-col cols="12" md="4" lg="4" class="mb-4 mb-md-8">
          <OrderSummary :cart-items="cartStore.cart" :grand-total="grandTotal" :tax-amount="taxAmount"
            :total-with-tax="totalWithTax" :loading="loading" :proceed-to-checkout="proceedToCheckout" />
        </v-col>
      </v-row>

      <!-- Clear Cart Dialog -->
      <!-- <v-dialog v-model="clearCartDialog" max-width="400">
        <v-card>
          <v-card-title class="text-h5">Clear Cart?</v-card-title>
          <v-card-text>Are you sure you want to remove all items from your cart?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn variant="text" @click="clearCartDialog = false">Cancel</v-btn>
            <v-btn color="error" variant="tonal" @click="clearCart">Clear</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> -->
    </v-container>
    <!-- {{ cartStore.cart }} -->
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useCartStore } from "@/Store/cartStore";
import Navbar from "../components/Navbar.vue";
import { useRouter } from "vue-router";
import { apiConfig } from "@/config/apiConfig";
import banner1 from "@/assets/images/administrator.jpg";
import OrderSummary from "../components/SharedUI/OrderSummary.vue";

const router = useRouter();
const cartStore = useCartStore();
const clearCartDialog = ref(false);
const loading = ref(false);

const taxRate = 0;
const taxAmount = computed(() => grandTotal.value * taxRate);
const totalWithTax = computed(() => grandTotal.value + taxAmount.value);
// const totalQuantity = computed(() => );
const recentProducts = ref([]); // Replace with real data

const grandTotal = computed(() =>
  cartStore.cart.reduce((sum, item) => sum + item.subTotal, 0)
);

// const cartCount = computed(() => cartStore.cartCount)

// const onQuantityChange = (item) => {
//   if (item.quantity < 1) {
//     item.quantity = 1;
//   }
//   cartStore.updateQuantity(item.id, item.quantity);
// };

const onQuantityChange = (item) => {
  // Ensure quantity is a number
  item.quantity = parseInt(item.quantity) || 50;

  // Apply minimum and maximum limits
  if (item.quantity < 50) item.quantity = 50;
  if (item.quantity > 9999) item.quantity = 9999;

  cartStore.updateQuantity(item.id, item.quantity);
};

// const getImage = (item) => {
//   console.log("item", item);
//   return item ? `${apiConfig.imageUrl}/${item}` : banner1;
// };
// import { getCurrentInstance } from 'vue';
// const { appContext } = getCurrentInstance();
// const getImage = appContext.config.globalProperties.$getImage;

const increaseQuantity = (item) => {
  cartStore.updateQuantity(item.id, item.quantity + 1);
};

const decreaseQuantity = (item) => {
  if (item.quantity > 1) cartStore.updateQuantity(item.id, item.quantity - 1);
};

const deleteItem = (id) => cartStore.removeItem(id);
const clearCart = () => {
  cartStore.clearCart();
  clearCartDialog.value = false;
};

const proceedToCheckout = async () => {
  if (!cartStore.cart.length) {
    alert("Your cart is empty");
    return;
  }

  loading.value = true;
  // Simulate an API call to process the order
  await new Promise((resolve) => setTimeout(resolve, 500));
  loading.value = false;

  router.push("/checkout");
};

// const formatPrice = (price) => price.toFixed(2);
const formatPrice = (value) => {
  if (value == null || isNaN(value)) return "0.00";
  return Number(value).toFixed(2);
};

// console.log("formatPrice", formatPrice(grandTotal.value));
const truncateDescription = (desc) =>
  desc.length > 50 ? desc.substring(0, 50) + "..." : desc;
</script>

<style scoped>
.cart-wrapper {
  background: #f9f9f9;
}

.cart-row {
  border-bottom: 1px solid #ececec;
  padding: 10px 20px;

}

.item-image {
  max-width: 100%;
  height: auto;
  width: 50px;
}

.v-field {
  width: 60px;
  height: 110px;
  text-align: center;
}

.v-field__field {
  width: 60px;
  height: 110px;
  text-align: center;
}

.v-chip {
  background-color: #e0e0e0;
  color: #333;
}

@media (max-width: 767px) {
  .cart-row td {
    padding: 1rem 0;
  }
}
</style>
